// extracted by mini-css-extract-plugin
export default {"responseitemquestion":"AssessmentResponseItem_responseitemquestion__CZcbp","responseitemanswer":"AssessmentResponseItem_responseitemanswer__dRaNx"};